export default __webpack_public_path__ + "3cba9e26d5a06bce2cd08a2045b11a3d.png";